import { LayoutDashboard, Wallet, ChartSpline, Sparkles } from "lucide-react"
import { NavItem } from "@/types/nav"

export const accountReceivablesNav: NavItem[] = [
  {
    title: "Dashboard",
    url: "/dashboard/account-receivables/dashboard/overview",
    icon: LayoutDashboard,
  },
  {
    title: "Receivables",
    url: "/dashboard/account-receivables/receivables",
    icon: Wallet,
    items: [
      {
        title: "Draft",
        url: "/dashboard/account-receivables/receivables/draft",
      },
      {
        title: "Approved",
        url: "/dashboard/account-receivables/receivables/approved",
      },
      {
        title: "Flagged",
        url: "/dashboard/account-receivables/receivables/flagged",
      },
      {
        title: "Rejected",
        url: "/dashboard/account-receivables/receivables/rejected",
      },
      {
        title: "Batches",
        url: "/dashboard/account-receivables/receivables/batches",
      },
    ],
  },
  {
    title: "Reports",
    url: "/dashboard/account-receivables/reports",
    icon: ChartSpline,
    items: [
      {
        title: "Tenant Charges",
        url: "/dashboard/account-receivables/reports/tenant-charges",
      },
      {
        // The page lives under /dashboard/utility-admin/reports/sla-breach-report
        // (built by feature/sla-breach-report on main). Backend permission
        // gate (IsSLABreachAuthorized) allows account_receivables. The URL
        // is exact-path-allowed for account_receivables in role-navigation.ts.
        title: "SLA Breach Report",
        url: "/dashboard/utility-admin/reports/sla-breach-report",
      },
    ],
  },
  {
    title: "AI Tools",
    url: "/dashboard/ai-tools",
    icon: Sparkles,
    items: [
      {
        title: "Fee Analyzer",
        url: "/dashboard/ai-tools/fee-analyzer",
      }
    ],
  },
]
